/* globals FormData */
import R from 'ramda'
import axios from '../axios'
import config from '../config'
import { customizeSearchCriteria } from '../Utils'

export const searchAdmins = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/admin/find`, criteria)
}

export const searchProperties = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/property/find`, criteria)
}

export const updateAdmin = admin => {
  return axios.put(`${config.SERVER_URL}/admin/${admin.id}`, admin)
}

export const createAdmin = admin => {
  return axios.post(`${config.SERVER_URL}/admin`, admin)
}

export const deleteAdmin = adminId => {
  return axios.delete(`${config.SERVER_URL}/admin/${adminId}`)
}

export const updateCategory = category => {
  return axios.put(`${config.SERVER_URL}/category/${category.id}`, category)
}

export const createCategory = category => {
  return axios.post(`${config.SERVER_URL}/category`, { name: category })
}

export const deleteCategory = id => {
  return axios.delete(`${config.SERVER_URL}/category/${id}`)
}

export const acceptUsers = users => {
  return axios.post(`${config.SERVER_URL}/user/accept`, {
    id: users.map(user => user.id)
  })
}

export const rejectUsers = users => {
  return axios.post(`${config.SERVER_URL}/user/reject`, {
    id: users.map(user => user.id)
  })
}

export const createUser = user => {
  const userData = R.clone(user)
  delete user.picture
  if (userData.picture && userData.picture.file) {
    return axios
      .post(`${config.SERVER_URL}/user`, user)
      .then(response => {
        let userId = response.data.id
        let formData = new FormData()
        formData.append('id', userId)
        formData.append('file', userData.picture.file)
        return axios.post(
          `${config.SERVER_URL}/user/${userId}/picture`,
          formData,
          { headers: { 'content-type': 'multipart/form-data' } }
        )
      })
      .catch(error => console.log(error))
  } else {
    return axios.post(`${config.SERVER_URL}/user`, user)
  }
}

export const updateUser = user => {
  const userData = R.clone(user)
  delete user.picture
  if (userData.picture && userData.picture.file) {
    return axios
      .put(`${config.SERVER_URL}/user/${user.id}`, user)
      .then(response => {
        let userId = response.data.id
        let formData = new FormData()
        formData.append('id', userId)
        formData.append('file', userData.picture.file)
        return axios.post(
          `${config.SERVER_URL}/user/${userId}/picture`,
          formData,
          { headers: { 'content-type': 'multipart/form-data' } }
        )
      })
      .catch(error => console.log(error))
  } else {
    return axios.put(`${config.SERVER_URL}/user/${user.id}`, user)
  }
}

export const deleteUser = user => {
  return axios.delete(`${config.SERVER_URL}/user/${user.id}`)
}

export const findUsers = ({ query = {}, skip = 0, limit = 30 }) => {
  return axios.post(`${config.SERVER_URL}/user/search`, { query, skip, limit })
}

export const searchUsers = (criteria = {}) => {
  return axios.post(`${config.SERVER_URL}/user/find`, criteria)
}

export const findUserById = id => {
  return axios.get(`${config.SERVER_URL}/user/${id}`)
}

export const filterUsers = (search, skip = 0, limit = 30) => {
  let query = R.clone(search)
  query.preferredCategories =
    (query.preferredCategories && query.preferredCategories.map(el => el.id)) ||
    []
  query.preferredCities =
    (query.preferredCities && query.preferredCities.map(el => el.id)) || []
  return axios.post(`${config.SERVER_URL}/user/searchUsers`, {
    skip,
    limit,
    query
  })
}

export const findUsersByName = name => {
  return axios.get(
    `${config.SERVER_URL}/user?where={"firstName":{"contains":"` +
      name +
      '"}}&sort="name ASC"'
  )
}

export const updateProperty = property => {
  if (property.picture.file) {
    let formData = new FormData()
    formData.append('id', property.id)
    formData.append('property', property.property)
    formData.append('file', property.picture.file)
    return axios
      .post(`${config.SERVER_URL}/property/${property.id}/picture`, formData, {
        headers: { 'content-type': 'multipart/form-data' }
      })
      .then(() => {
        delete property.picture
        return axios.put(
          `${config.SERVER_URL}/property/${property.id}`,
          property
        )
      })
      .catch(error => console.log(error))
  } else {
    return axios.put(`${config.SERVER_URL}/property/${property.id}`, property)
  }
}

export const deleteProperty = id => {
  return axios.delete(`${config.SERVER_URL}/property/${id}`)
}

export const createProperty = property => {
  let propertyToCreate = R.clone(property)

  if (propertyToCreate.area === '') {
    delete propertyToCreate.area
  }

  if (propertyToCreate.usableArea === '') {
    delete propertyToCreate.usableArea
  }

  if (property.picture) {
    delete propertyToCreate.picture
    return axios
      .post(`${config.SERVER_URL}/property/`, propertyToCreate)
      .then(response => {
        const prop = response.data
        let formData = new FormData()
        formData.append('id', prop.id)
        formData.append('file', property.picture.file)
        return axios.post(
          `${config.SERVER_URL}/property/${prop.id}/picture`,
          formData,
          { headers: { 'content-type': 'multipart/form-data' } }
        )
      })
      .catch(error => console.log(error))
  } else {
    return axios.post(`${config.SERVER_URL}/property/`, propertyToCreate)
  }
}

export const updateCity = city => {
  const data = R.clone(city)
  delete data.picture
  data.country = data.country.id
  if (city.picture.file) {
    let formData = new FormData()
    formData.append('id', city.id)
    formData.append('file', city.picture.file)
    return axios
      .post(`${config.SERVER_URL}/city/${city.id}/picture`, formData, {
        headers: { 'content-type': 'multipart/form-data' }
      })
      .then(response => {
        return axios.put(`${config.SERVER_URL}/city/${city.id}`, data)
      })
      .catch(error => console.log(error))
  } else {
    return axios.put(`${config.SERVER_URL}/city/${city.id}`, data)
  }
}

export const createCity = city => {
  const cityData = R.clone(city)
  delete city.picture
  if (cityData.picture && cityData.picture.file) {
    return axios
      .post(`${config.SERVER_URL}/city`, city)
      .then(response => {
        let cityId = response.data.id
        let formData = new FormData()
        formData.append('id', cityId)
        formData.append('file', cityData.picture.file)
        return axios.post(
          `${config.SERVER_URL}/city/${cityId}/picture`,
          formData,
          { headers: { 'content-type': 'multipart/form-data' } }
        )
      })
      .catch(error => console.log(error))
  } else {
    return axios.post(`${config.SERVER_URL}/city`, city)
  }
}

export const deleteCity = id => {
  return axios.delete(`${config.SERVER_URL}/city/${id}`)
}

export const exportPropertiesToCsv = query => {
  return axios.post(`${config.SERVER_URL}/property/export_properties`, {
    criteria: customizeSearchCriteria(query),
    columns: [
      'title',
      'country',
      'city',
      'continent',
      'category',
      'price',
      'noRooms',
      'yield',
      'usableArea'
    ]
  })
}

export const addUsersToProperties = (propertiesIds, usersIds) => {
  return axios.post(`${config.SERVER_URL}/property/add_permission`, {
    usersIds,
    propertiesIds
  })
}

export const updateContinent = continent => {
  const data = R.clone(continent)
  delete data.picture
  delete data.countries
  delete continent.countries
  if (continent.picture.file) {
    let formData = new FormData()
    formData.append('id', continent.id)
    formData.append('file', continent.picture.file)
    return axios
      .post(
        `${config.SERVER_URL}/continent/${continent.id}/picture`,
        formData,
        { headers: { 'content-type': 'multipart/form-data' } }
      )
      .then(response => {
        return axios.put(`${config.SERVER_URL}/continent/${continent.id}`, data)
      })
      .catch(error => console.log(error))
  } else {
    return axios.put(`${config.SERVER_URL}/continent/${continent.id}`, data)
  }
}

export const createContinent = continent => {
  const continentData = R.clone(continent)
  delete continent.picture
  if (continentData.picture && continentData.picture.file) {
    return axios
      .post(`${config.SERVER_URL}/continent`, continent)
      .then(response => {
        let continentId = response.data.id
        let formData = new FormData()
        formData.append('id', continentId)
        formData.append('file', continentData.picture.file)
        return axios.post(
          `${config.SERVER_URL}/continent/${continentId}/picture`,
          formData,
          { headers: { 'content-type': 'multipart/form-data' } }
        )
      })
      .catch(error => console.log(error))
  } else {
    return axios.post(`${config.SERVER_URL}/continent`, continent)
  }
}

export const deleteContinent = id => {
  return axios.delete(`${config.SERVER_URL}/continent/${id}`)
}

export const updateCountry = country => {
  country.continent = country.continent.id
  const data = R.clone(country)
  delete data.picture
  delete data.cities
  delete country.cities
  if (country.picture.file) {
    let formData = new FormData()
    formData.append('id', country.id)
    formData.append('file', country.picture.file)
    return axios
      .post(`${config.SERVER_URL}/country/${country.id}/picture`, formData, {
        headers: { 'content-type': 'multipart/form-data' }
      })
      .then(response => {
        return axios.put(`${config.SERVER_URL}/country/${country.id}`, data)
      })
      .catch(error => console.log(error))
  } else {
    return axios.put(`${config.SERVER_URL}/country/${country.id}`, data)
  }
}

export const createCountry = country => {
  const countryData = R.clone(country)
  delete country.picture
  if (countryData.picture && countryData.picture.file) {
    return axios
      .post(`${config.SERVER_URL}/country`, country)
      .then(response => {
        let countryId = response.data.id
        let formData = new FormData()
        formData.append('id', countryId)
        formData.append('file', countryData.picture.file)
        return axios.post(
          `${config.SERVER_URL}/country/${countryId}/picture`,
          formData,
          { headers: { 'content-type': 'multipart/form-data' } }
        )
      })
      .catch(error => console.log(error))
  } else {
    return axios.post(`${config.SERVER_URL}/continent`, country)
  }
}

export const deleteCountry = id => {
  return axios.delete(`${config.SERVER_URL}/country/${id}`)
}

export const uploadNda = user => {
  let formData = new FormData()
  formData.append('id', user.id)
  formData.append('file', user.nda)
  return axios.post(`${config.SERVER_URL}/user/${user.id}/nda`, formData, {
    headers: { 'content-type': 'multipart/form-data' }
  })
}



// WEBPACK FOOTER //
// ./src/sources/AdminSource.js